import { Link } from 'react-router-dom';
import { DF_URL } from '../constants';

function Navbar() {
  return (
    <nav className="wf-navbar">
      <div className="wf-container wf-nav-content">
        <Link to="/" className="wf-logo">Winvasion</Link>
        <div className="wf-nav-links">
          <Link to="/#linecrm">LINE CRM</Link>
          <Link to="/#magnusfamous">Magnus Famous Scheduler</Link>
          <Link to="/#ceasarsbag">Crypto Portfolio</Link>
          <a href={DF_URL} target="_blank" rel="noreferrer">Novels</a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
